import { getFormedEltTranslation } from 'legacy/lut/components/widgets/public/partner360/ELT/helpers/getFormedEltTranslation'
import { IPartnerGroupAdditionalInfo } from 'legacy/lut/components/widgets/public/partner360/ELT/models/IPartnerGroupAdditionalInfo'
import React, { useCallback, useState } from 'react'

import { Translation } from 'cng-common/features/translations'
import { Switch } from 'core-components/library/checkbox'
import { ConfirmationDialog } from 'partner360/components/confirmationDialog/ConfirmationDialog'

import styles from './RollupSwitcher.module.scss'

interface IRollupSwitcherProps {
  isTurnOn?: number
  onToggleRollupMode: (flag: boolean) => void
  partnerGroupInfo: IPartnerGroupAdditionalInfo
}

export const RollupSwitcher = ({
  isTurnOn,
  onToggleRollupMode,
  partnerGroupInfo,
}: IRollupSwitcherProps) => {
  const [isShowDialog, setIsShowDialog] = useState(false)
  const [pendingValue, setPendingValue] = useState<boolean | null>(null)

  const isChecked = Boolean(isTurnOn)

  const handleFlagChange = useCallback((flag: boolean) => {
    setPendingValue(flag)
    setIsShowDialog(true)
  }, [])

  const handleConfirm = useCallback(() => {
    if (pendingValue === null) {
      return
    }

    onToggleRollupMode(pendingValue)
    setPendingValue(null)
    setIsShowDialog(false)
  }, [onToggleRollupMode, pendingValue])

  const handleReject = useCallback(() => {
    setPendingValue(null)
    setIsShowDialog(false)
  }, [])

  if (!partnerGroupInfo.groupId) {
    return null
  }

  return (
    <div className={styles.switchBg}>
      <Switch size="sm" checked={isChecked} onChange={handleFlagChange} />

      <div className={styles.switchLabel}>
        <Translation text={getFormedEltTranslation('toggle-rollup')} />
      </div>

      <ConfirmationDialog
        title={getFormedEltTranslation('toggle-rollup-dialog-title')}
        content={getFormedEltTranslation('toggle-rollup-dialog-content')}
        confirmBtnText={getFormedEltTranslation('toggle-rollup-dialog-apply')}
        rejectBtnText={getFormedEltTranslation('toggle-rollup-dialog-cancel')}
        isVisible={isShowDialog}
        onConfirm={handleConfirm}
        onReject={handleReject}
      />
    </div>
  )
}
